<template>
  <div class="nav-bar">
      <div class="nav-left">
        <img src="../../assets/image/logo-color.png" class="logo" />
      </div>
      <p class="nav-center">导向医疗产品数据中心</p>

      <div class="nav-right">
        <!-- <router-link class="fix" :to="{path:'/display'}" v-if="showActionMap==true">大屏展示</router-link> -->
        <!-- <button class="fix" @click="display()" v-if="showActionMap==true">大屏展示</button> -->
      </div>


      <!-- <el-button
        @click="show()"
        autofocus
        class="fix"
        >大屏展示
        </el-button> -->
    <!-- </div> -->
  </div>
</template>

<script>
  import {permissionCheckUtil} from '../../utils/permission.js'
  export default {
    data() {
      return {
        showActionMap:false
      }
    },
    methods: {
      // display(){
      //   this.$router.replace('/display');
      // },
    },
    mounted() {
      var map1 = permissionCheckUtil.findName('statistics:map')
      if(map1 ==true){
        this.showActionMap = true
      }
    },
    created() {

    }
  }
</script>

<style lang="scss" scoped>
.nav-bar {
  height: 100px;
  background: url('../../assets/image/home/show_top.png') no-repeat;
  -moz-background-size: 100% 100%;
  background-size: 100% 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

    .nav-left{
      float: left;
      width: 10%;
      margin-left: 10px;


      .logo{
        float: left;
        // font-weight: 400;
        margin-top: -32px;
        background-color:rgba(255,255,255,1);
        border-radius:2px;
        padding:3px;
      }
    }

  .nav-center{
    color: #fff;
    font: 30px bold solid;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;

    width: 26%;
  }

  img{
    margin-top: -23px;
    height: 36px;
  }

  .nav-right{
    float: right;
    width: 10%;
    margin-right: 10px;

    .fix{
      float: right;
      text-decoration: none;
      margin-top: -15px;
      width: 100%;
      border: 0;
      text-align: right;
      color: #00EBF4;
      font: 18px bold solid;
      color: #fff;
      font-family: Verdana, Geneva, Tahoma, sans-serif;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/nav-bar.vue